export default "__VITE_PUBLIC_ASSET__e801d833__"